import styled from "styled-components";

const DialogContent = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 10px;
`
export default DialogContent;